import React, { useState, useEffect } from 'react';
import '../scss/ImageCarousel.scss';
import '../scss/responsive.scss';

interface Slide {
  imageUrl: string;
  title: string;
  description: string;
}

const slides: Slide[] = [
  {
    imageUrl: '/slide4.jpg',
    title: 'Upptäck våra kvalitetsprodukter',
    description: 'Produkter av högsta kvalitet'
  },
  {
    imageUrl: '/slide5.jpg',
    title: 'Säsongens favoriter',
    description: 'Handla smart och hållbart med Accordi'
  },
  {
    imageUrl: '/restu.jpg',
    title: 'Fyll på lagret nu',
    description: 'Passa på medan lagret är fullt – populära produkter tar snabbt slut'
  }
];

const ImageCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Changing picture every 5 sec
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToPrev = () => {
    setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % slides.length);
  };

  return (
    <div className="carousel">
      <div className="carousel-slide">
        <img src={slides[currentIndex].imageUrl} alt={slides[currentIndex].title} />
        <div className="carousel-text">
          <h2>{slides[currentIndex].title}</h2>
          <p>{slides[currentIndex].description}</p>
        </div>
      </div>
      <button className="carousel-button prev" onClick={goToPrev} aria-label="Föregående bild">&#10094;</button>
      <button className="carousel-button next" onClick={goToNext} aria-label="Nästa bild">&#10095;</button>
      <div className="carousel-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(i)}
            aria-label={`Bild ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
